export default __webpack_public_path__ + "static/media/business.e1745240.svg";